var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-flex-col tw-items-center tw-gap-3"},[_c('h1',{staticClass:"tw-text-lg"},[_vm._v("\n    Pinia Example\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    "+_vm._s(_vm.exampleStore.count)+" * 3 = "+_vm._s(_vm.exampleStore.tripled)+"\n  ")]),_vm._v(" "),_c('PiniaExampleComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }